export default {
      id: "note-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#note",
      toString: function () {
        return this.url;
      }
    }